import { useState } from "react";

import Button from "../../../components/Button";
import Input from "../../../components/Input";
import Doghouse from "../../../assets/doghouse.png";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import referralSchema from "../schemas/referralSchema";

import { submitReferral } from "../api/questionnaireRequest";

const SallieReferral = () => {
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors, isSubmitting },
    } = useForm({
        resolver: yupResolver(referralSchema),
    });

    const onSubmit = async (data) => {
        setError("");
        try {
            await submitReferral({
                recipientEmail: data.email,
            });
            setSuccess(`Referral email has been sent to ${data.email}`);
            reset();
        } catch (err) {
            console.error("Referring to Sallie Error", err);
            setError(
                err.response.data.message ||
                    "Failed to send referral. Please try again."
            );
        }
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <h3 className="md:text-base text-sm mb-2 text-center">
                Refer someone to Sallie and help them track their symptoms!
            </h3>
            <img
                src={Doghouse}
                className="max-w-48 aspect-square mx-auto"
            />
            <div className="flex flex-col gap-2 mb-2 md:flex-row md:items-start md:justify-center">
                <Input
                    name="email"
                    register={register}
                    errors={errors}
                    placeholder="Enter their email"
                    className="w-full mb-5 md:w-auto"
                />
                <Button
                    type="submit"
                    isLoading={isSubmitting}
                    className="w-full mb-5 md:w-auto"
                >
                    Refer to Sallie
                </Button>
            </div>
            {success && <p className="text-teal-600 text-center">{success}</p>}
            {error && <p className="text-red-600 text-center">{error}</p>}
        </form>
    );
};

export default SallieReferral;